import * as Headless from '@headlessui/react'
import clsx from 'clsx'
import React, { forwardRef } from 'react'

export const Textarea = forwardRef(function Textarea(
  { className, ...props },
  ref
) {
  return (
    <span
      data-slot="control"
      className={clsx(
        'relative block w-full',
        'before:absolute before:inset-px before:rounded-[calc(theme(borderRadius.lg)-1px)] before:bg-white before:shadow',
        'dark:before:hidden',
        'after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-1 after:ring-inset after:ring-gray-950/10',
        'dark:after:ring-white/10',
        'has-[[data-invalid]]:after:ring-red-500'
      )}
    >
      <Headless.Textarea
        ref={ref}
        className={clsx(
          'relative block w-full appearance-none rounded-lg px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing.3)-1px)] sm:py-[calc(theme(spacing[1.5])-1px)]',
          'text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6 dark:text-white',
          'border border-gray-950/10 data-[hover]:border-gray-950/20 dark:border-white/10 dark:data-[hover]:border-white/20',
          'bg-transparent dark:bg-white/5',
          'focus:outline-none',
          'data-[invalid]:border-red-500 data-[invalid]:data-[hover]:border-red-500 data-[invalid]:dark:border-red-600 data-[invalid]:data-[hover]:dark:border-red-600',
          'disabled:border-gray-950/20 dark:disabled:border-white/15 disabled:dark:bg-white/[2.5%]',
          'disabled:!text-gray-500 dark:disabled:!text-gray-600',
          'resize-y',
          className
        )}
        {...props}
      />
    </span>
  )
})